module.exports = __webpack_public_path__ + "img/Mapcity-logo.ecf92040.jpg";